<template>
  <div class="cabinet-state" :class="`cabinet-state--${type}`">
    <strong>{{ title }}</strong>
    <p v-if="message">{{ message }}</p>
    <button v-if="type === 'error'" type="button" @click="$emit('retry')">{{ $t('common.tryAgain') }}</button>
  </div>
</template>

<script>
export default {
  name: 'CabinetState',
  props: {
    type: { type: String, default: 'empty' },
    title: { type: String, required: true },
    message: { type: String, default: '' },
  },
}
</script>

<style lang="sass" scoped>
.cabinet-state
  display: flex
  flex-direction: column
  align-items: center
  justify-content: center
  min-height: 180px
  padding: 28px 20px
  border: 1px solid #e9e4d9
  border-radius: 20px
  background: #fffdf8
  color: #68665f
  text-align: center

  strong
    color: #282a24
    font-size: 16px
    font-weight: 600

  p
    max-width: 280px
    margin-top: 7px
    font-size: 13px
    line-height: 1.45

  button
    margin-top: 18px
    padding: 11px 22px
    border-radius: 22px
    background: #393a2f
    color: #fff
    font-weight: 600
</style>
